export type ILoadExternalSources = (suffix?: string, formId?: string) => void;

export function loadExternalSources(suffix = '', formId?: string) {
  const _fieldSuffix = suffix || window.fieldSuffix;
  const _formId = formId || window.isFormPageIdentifier;
  if (window.debug) {
    console.info('loadExternalSources fire');
  }
  try {
    const externalSources = (window as any)[
      `externalSources${_fieldSuffix}`
    ] as IDCA.IExternalSource[];
    if (typeof externalSources === 'object' && externalSources.length) {
      window.DexeroCoreApp.initializeExternalSources(externalSources, _fieldSuffix, _formId);
    }
  } catch (e) {
    console.error(e);
  }
}
